import config from 'constants/config'

function getLuxLoyaltyTierDisplayName(tier: App.LuxLoyaltyTier): string {
  return config.luxLoyalty.tiers[tier].displayName
}

export default getLuxLoyaltyTierDisplayName
